"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArraySchema = exports.isQuerySchema = exports.normalize = void 0;
const query_key_1 = require("./query-key");
function normalize(setEntity, query, data) {
    try {
        const normalized = _normalize(setEntity, query, data, query.model.schema);
        setEntity(query, normalized);
    }
    catch (e) {
        const error = new Error(`Error while normalizing ${query_key_1.getQueryKey(query)}: `);
        error.stack = e.stack;
        throw error;
    }
}
exports.normalize = normalize;
function isQuerySchema(schema) {
    return typeof schema === "function";
}
exports.isQuerySchema = isQuerySchema;
function isArraySchema(schema) {
    return Array.isArray(schema);
}
exports.isArraySchema = isArraySchema;
function _normalize(setEntity, query, data, schema) {
    if (!schema) {
        return data;
    }
    if (data == null) {
        return data;
    }
    if (isQuerySchema(schema)) {
        const nestedQuery = schema(data, query);
        const nestedQueryKey = query_key_1.getQueryKey(nestedQuery);
        if (nestedQueryKey !== query_key_1.getQueryKey(query)) {
            const normalized = _normalize(setEntity, nestedQuery, data, nestedQuery.model.schema);
            setEntity(nestedQuery, normalized);
            return nestedQueryKey;
        }
        return data;
    }
    if (typeof data !== "object") {
        return data;
    }
    if (isArraySchema(schema)) {
        if (!Array.isArray(data)) {
            throw new Error(`Expected an array, but received: ${data}`);
        }
        const nestedSchema = schema[0];
        return data.map((item) => _normalize(setEntity, query, item, nestedSchema));
    }
    if (Array.isArray(data)) {
        throw new Error(`Expected an object, but received: ${data}`);
    }
    const normalized = Object.assign({}, data);
    Object.entries(schema).forEach(([key, nestedSchema]) => {
        const normalizedValue = _normalize(setEntity, query, data[key], nestedSchema);
        if (normalizedValue !== undefined) {
            normalized[key] = normalizedValue;
        }
    });
    return normalized;
}
